import  UserRole  from "../enums/UserRole";
import  UserStatus from "../enums/UserStatus";

export default class User
{
    id?: string;
    name?:string;        
    phone?:string;
    token?: string;
    role: UserRole;
    status: UserStatus;
    profileImage?: string;
    emailVerified?: boolean;
    dob?:string;
    address?: string;
    createdAt?: Date;
    updatedAt?: Date;
    constructor(
    ){
        this.role = UserRole.USER;
        this.status = UserStatus.PENDING;
    }

}
  